import { useEffect } from 'react';
import { Intercom as IntercomMessenger } from '@intercom/messenger-js-sdk';
import { useAuth } from '../context/AuthContext';

export const useIntercom = () => {
  const { user, userProfile, isAuthenticated } = useAuth();

  useEffect(() => {
    // Only initialize if app ID is configured
    if (!process.env.REACT_APP_INTERCOM_APP_ID) {
      console.warn('Intercom app ID not configured');
      return;
    }

    // Initialize Intercom when auth state is available
    if (isAuthenticated && user) {
      // Boot Intercom with user data for authenticated users
      IntercomMessenger({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        user_id: user.id,
        name: userProfile?.name || user.email?.split('@')[0] || 'User',
        email: user.email,
        created_at: user.created_at
          ? Math.floor(new Date(user.created_at).getTime() / 1000)
          : Math.floor(Date.now() / 1000)
      });
    } else {
      // Boot Intercom for anonymous/unauthenticated users
      IntercomMessenger({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID
      });
    }

    // Cleanup on unmount
    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [isAuthenticated, user, userProfile]);
};
